module.exports = __webpack_public_path__ + "static/media/our_clients_one.c6f6bd3a.png";